export default __webpack_public_path__ + "2026 Enhancing Infrared-Laser Dissociation of Molecules with the Electromagnetic Vacuum.pdf";